import { useContext } from 'react';

import { KeystoneContext } from './keystone-provider';
import type { KeystoneSession } from './types';

export const useKeystoneSession = (): KeystoneSession => {
	return useContext(KeystoneContext);
};
